import FormInput from 'components/Input/FormInput';
import React from 'react';

interface IExternalIdField {
	changeExternalId: (value: string) => void;
}

const ExternalIdField: React.FC<IExternalIdField> = ({ changeExternalId }) => {
	return <FormInput testId="ExternalIdField" name="externalId" label="externalIdLabel" onChange={changeExternalId} />;
};

export default React.memo(ExternalIdField);
